module.exports = __webpack_public_path__ + "assets/img/mask-bg4-long.f6eaa611.png";